import React, { Component } from 'react';
import Select from 'react-select';
import OgaSelect from "../elements/OgaSelect";

export default class TransactionTypeSelect extends Component {

    constructor(props) {
        super(props);
    }

    handleChange = (status) => {
        this.props.handleChange(status);
    }

    render() {
        const statuses = [
            { value: null, label: 'TODOS' },
            { value: 'IN', label: 'INGRESO' },
            { value: 'OUT', label: 'EGRESO' }
        ];
        return (
            <OgaSelect
                bsSize="small"
                placeholder="INGRESO/EGRESO"
                value={this.props.selection}
                onChange={(status) => this.handleChange(status)}
                options={statuses}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/TransactionTypeSelect/TransactionTypeSelect.jsx